import React, { useEffect, useState } from "react";
import { Link } from 'react-router-dom';
import './Style/SubjectTopics.css';
import SubjectTopicName from "../AllData/SubjectTopicName";
import StudyOption from "../AllData/HomeData";
import AllQuestions from "../AllData/AllQuestions";
import TopNavbar from "../home/TopNavbar";
import TopHeader from "../home/TopHeader";
import PaidItems from "../AllData/PaidItems";



function PracticsQuestionTopics({ subject, type }) {
    const [topicsList, setTopicsList] = useState([]);
    const [savedQuestions, setSavedQuestions] = useState([]);
    const questions = AllQuestions;

    const topicsName = SubjectTopicName;
    const studyOptions = StudyOption;

    const matchingItem = studyOptions?.find(item => item.id === type);
    const iconName = matchingItem ? matchingItem.symbol : '';


    // Check payment
    const isPayment = localStorage.getItem('userPayment');
    const phone = localStorage.getItem('userPhone');

    const paidItems = PaidItems;
    const isPaid = paidItems.includes(type);

    const demoType = ["dpp", "diagrambasedquestions", "previousyearquestions"];
    const demoTopics = ["CP01", "CC01", "CB01", "2024"];
    const isDemo = (topic) => {
        return demoTopics.includes(topic) && demoType.includes(type);
    }



    useEffect(() => {
        const filteredTopicsName = topicsName.filter(topicsName =>
            topicsName.topicssubject === subject && topicsName.topicstype === type
        );
        setTopicsList(filteredTopicsName);
        //  setLoading(false);
    }, [topicsName, subject, type]);



    useEffect(() => {
        const storedQuestions = JSON.parse(localStorage.getItem('saveQuestionsIdInLocalStorage')) || [];
        setSavedQuestions(storedQuestions);
    }, []);

    const CountTotalQuestions = (subject, topic, type) => {
        return questions.filter(question =>
            question.subject === subject && question.type === type && (question.topic === topic || question.year === topic)
        ).length;
    };

    const CountTotalQuestionSolved = (subject, topic, type) => {
        const totalQuestions = questions.filter(question =>
            question.subject === subject &&
            question.type === type &&
            (question.topic === topic || question.year === topic)
        );



        const solvedQuestionIds = totalQuestions.filter(question =>
            savedQuestions.some(saved => saved === question._id.$oid)
        ).map(question => question._id.$oid);

        return solvedQuestionIds.length;
    };




    const PercentageBar = ({ percentage }) => {
        const normalizedPercentage = Math.max(0, Math.min(100, percentage));

        let color;

        if (normalizedPercentage >= 90) {
            color = '#00ff08ff';
        } else if (normalizedPercentage >= 80) {
            color = '#a4ff3dff';
        } else if (normalizedPercentage >= 70) {
            color = '#d0ffa4ff';
        } else if (normalizedPercentage >= 60) {
            color = '#cebe2cff';
        } else if (normalizedPercentage >= 50) {
            color = '#b2b430ff';
        } else if (normalizedPercentage >= 40) {
            color = '#f8ec7dff';
        } else if (normalizedPercentage >= 30) {
            color = '#fff23fff';
        } else if (normalizedPercentage >= 20) {
            color = '#fab650ff';
        } else if (normalizedPercentage >= 10) {
            color = '#ff6363ff';
        } else {
            color = '#ff0707ff';
        }


        const containerStyle = {
            width: '100%',
            height: '10px',
            backgroundColor: '#e0e0e0',
            borderRadius: '10px',
            overflow: 'hidden',
            marginTop: '10px'
        };

        const fillStyle = {
            width: `${normalizedPercentage}%`,
            height: '100%',
            backgroundColor: color,
            transition: 'width 0.5s ease-in-out',
            borderRadius: '10px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'flex-end',
            paddingRight: '8px',
            boxSizing: 'border-box',
        };

        const textStyle = {
            color: normalizedPercentage > 40 ? '#fff' : '#333',
            fontWeight: 'bold',
            fontSize: '12px',
            whiteSpace: 'nowrap',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        };

        return (
            <div style={containerStyle}>
                <div style={fillStyle}>
                    {normalizedPercentage > 0 && (
                        <span style={textStyle}>{`${normalizedPercentage}`}{normalizedPercentage > 10 && (<>%</>)}</span>
                    )}
                </div>
            </div>
        );
    };


    return (
        <div className="subject-topics-page">

            <TopNavbar name={subject.charAt(0).toUpperCase() + subject.slice(1)} />
            <TopHeader name={subject.charAt(0).toUpperCase() + subject.slice(1)} />


            <div className="topics-container">




                {topicsList.map((topic) => {

                    const totalQuestions = CountTotalQuestions(subject, topic.topicssymbol, type);
                    const totalQuestionSolved = CountTotalQuestionSolved(subject, topic.topicssymbol, type);
                    const percentage = totalQuestions > 0 ? Math.round((totalQuestionSolved / totalQuestions) * 100) : 0;

                    return (
                        <div className="topic-card" key={topic._id}>

                            {isPayment || !isPaid || isDemo(topic.topicssymbol) ? (<>

                                {(type == 'diagrambasedquestions' ) ? (<>
                                    <Link to={`/question-image-load/${subject}/${topic.topicssymbol}/${type}`} className="link">
                                        <div className="topic-header">
                                            <h3> {iconName} {topic.topicsname}</h3>
                                            <p>({totalQuestionSolved} /{totalQuestions})</p>
                                        </div> 
                                        <PercentageBar percentage={percentage} />
                                    </Link>
                                </>) : (<>
                                    <Link to={`/online-practics-questions/${subject}/${topic.topicssymbol}/${type}`} className="link">
                                        <div className="topic-header">
                                            <h3> {iconName} {topic.topicsname}</h3>
                                            <p>({totalQuestionSolved} /{totalQuestions})</p>
                                        </div>
                                        <PercentageBar percentage={percentage} />
                                    </Link>
                               </>)}

                            </>) : (<>

                                <Link to="/premium-paywall" className="link">
                                    <div className="topic-header">
                                        <h3> {iconName} {topic.topicsname}</h3>
                                        <p>🔒({totalQuestionSolved} /{totalQuestions})</p>
                                    </div>
                                    <PercentageBar percentage={percentage} />

                                </Link>
                            </>)}


                        </div>
                    );
                })}


            </div>
        </div>
    );
}

export default PracticsQuestionTopics;